// import React, { Component } from 'react';
// import { connect } from 'react-redux';
// import {
//   withRouter,
// } from 'react-router-dom';
//
// import {
//   Grid,
//   Typography,
// } from '@material-ui/core';
// import MainLayout from '../../common/components/MainLayout';
// import { PDFReader } from "reactjs-pdf-reader";
//
// import * as mainActions from '../actions';
// import classes from '../../css/getCSS';
//
//
// class TermsAndConditions extends Component {
//   componentDidMount() {
//     document.title = 'Terms & Conditions';
//     window.scrollTo(0, 0);
//     this.props.deepUnmount();
//   }
//
//   componentWillUnmount() {
//     this.props.deepUnmount();
//   }
//
//   render() {
//     let rootClass = null;
//     if (this.props.token) {
//       rootClass = classes.dashboardLayout;
//     }
//
//     return (
//       <MainLayout rootClass={rootClass} isAuthenticated={this.props.token !== null}>
//         <Grid container style={{ justifyContent: 'center' }}>
//           <Grid item md={6} sm={8} xs={12}>
//             <Typography variant="display1">Terms & Conditions</Typography>
//             <span className={classes.titleUnderline} />
//             {/*<object height="700" width="600" data="https://africau.edu/images/default/sample.pdf" type="application/pdf"></object>*/}
//             <PDFReader height="700" width="600" showAllPage={true} url={} />
//           </Grid>
//         </Grid>
//       </MainLayout>
//     );
//   }
// }
//
//
// const mapStateToProps = (state) => {
//   return {
//     site: state.common.site,
//     token: state.auth.token,
//     loading: state.main.loading,
//     error: state.main.error,
//     eventList: state.main.eventList,
//     count: state.main.count,
//     next: state.main.next,
//   };
// };
//
// const mapDispatchToProps = (dispatch) => {
//   return {
//     onUnmount: () => dispatch(mainActions.onUnmount()),
//     deepUnmount: () => dispatch(mainActions.deepUnmount()),
//   };
// };
//
// export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TermsAndConditions));





import React from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';

import {
  Typography,
  Grid,
  Paper,
  Button,
} from '@material-ui/core';
import { PDFReader } from "reactjs-pdf-reader";
// import PDFViewer from 'pdf-viewer-reactjs'

import MainLayout from '../../common/components/MainLayout';
import classes from '../../css/getCSS';
import * as routes from '../../config/routes';
import {useEffect} from 'react';




const TermsAndConditions = (props) => {

  useEffect(() => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, );


  console.log('classes>>>',classes);
  console.log(props);
  const activePage = props.match.params.page;

  let title = null;
  let file = null;

  if (activePage === 'termsAndConditions') {
    document.title = 't&c'
    title = 'Terms & Conditions';
    file = "/Lagna-Setu-Terms-and-Conditions.pdf";
  }

  if (activePage === 'disclaimer') {
    document.title = 'disclaimer'
    title = 'Disclaimer';
    file = "/Lagna Setu - Website DISCLAIMER - 15.08.2022 -.docx - Google Docs.pdf";
  }

  if (activePage === 'privacyPolicy') {
    document.title = 'privacy Policy'
    title = 'Privacy Policy';
    file = "/Lagna-Setu-privacy-Policy-Disclaimer.pdf";
  }


  return (
    <MainLayout termsAndCondition={true}>
      <Grid container style={{ justifyContent: 'center' }}>
        <Grid item md={8} sm={10} xs={12}>
          <Paper className={[classes.card].join(' ')}>
            <Typography variant="headline">{title}</Typography>
            <span className={classes.titleUnderline} />
            {/*<div style={{width: '100%', paddingTop: '56.25%', height: '0px', position: 'relative'}}>*/}
            {/*<object style={{width: '100%', height: '100%', position: 'absolute', top: '0px', 'left': '0px'}}*/}
            {/*        data={"/test_pdf.pdf"} type="application/pdf"></object>*/}

            <div className={classes.pdfReader}>
            <PDFReader showAllPage={true} url={file} />
            </div>
            {/*</div>*/}
          </Paper>
        </Grid>
      </Grid>
    </MainLayout>
  );
};



export default TermsAndConditions;




// WEBPACK FOOTER //
// ./src/main/containers/TermsAndConditions.js